import React from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppSystemUserService from '../AppSystemUsersService';

//hooks
import { useRouter } from '../../../shared/hooks/useRouter';

//global components
import ModalButton from '../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
} from '../../../SharedStyles';

const TokenModal = (props) => {
  const { strings } = AppSystemUserService;
  const router = useRouter();
  const { token } = props;

  const closeModal = () => {
    router.history.push('/system-users');
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.tokenTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>{strings.tokenInvite}</p>
            <h4>{strings.tokenSubtitle}</h4>
            <h4>{token.token}</h4>
            <p>{strings.tokenContent}</p>
          </ModalItemStyles>
          {/* Section */}
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={closeModal}
          buttonText={strings.tokenButton}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default TokenModal;
